import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import NumberField from 'components/number-field';
import { useIntl } from 'react-intl';
import { UpdateScenarioFinancialDataInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-financial-data-input.type';

const TreatmentCostSection: React.FC = () => {
  const { control } = useFormContext<UpdateScenarioFinancialDataInput>();
  const intl = useIntl();

  const treatmentFields = [
    {
      label: 'Treatments',
      name: 'treatmentsPerCage',
      endAdornment: '/ cage',
    },
    {
      label: 'Cost',
      name: 'costOfSingleTreatment',
      endAdornment: '/ treatment',
    },
  ];

  return (
    <Box display={'flex'} flexDirection={'column'} gap={8}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 4,
        }}>
        {treatmentFields.map((field) => (
          <NumberField
            key={field.name}
            dark
            label={field.label}
            fullWidth
            decimalScale={3}
            endAdornment={field.endAdornment}
            controller={{
              control,
              name: field.name,
              rules: {
                required: intl.formatMessage({ id: 'form.rules.required' }),
                validate: {
                  greaterThanZero: (value) => (value >= 0 ? true : intl.formatMessage({ id: 'form.rules.moreThanZero' })),
                },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TreatmentCostSection;
